
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetolonavala() {



    const cardData =
    {
        keyword: 'Pune to Lonavala Taxi',
        heading: 'Meghana Cab : Pune to Lonavala Taxi',
        headingDescription: 'Meghana Cab offers Pune to Lonavala Taxi services, perfect for a relaxing getaway to the scenic hill station. Whether you are planning a one-day picnic, weekend retreat, or romantic escape, our clean and comfortable taxis ensure a smooth and pleasant ride. Enjoy well-maintained vehicles, professional drivers, and flexible booking options at affordable rates. With on-time pickups and round-the-clock support, Meghana Cab makes your Pune to Lonavala travel easy and enjoyable. Book now for a safe and memorable journey!',


        top: 'Top Places to Visit in Lonavala with Meghana Cab',

"topPlaces": [
  {
    "title": "Tiger’s Point (Tiger’s Leap)",
    "description": "Tiger’s Point is a popular cliff-top destination in Lonavala that offers dramatic views of the lush valley and waterfalls below, especially during the monsoon season. The echo point and steep drop resemble a leaping tiger, giving the place its name. It's an ideal spot for nature lovers, photographers, and those seeking a peaceful escape amidst clouds and cool breezes."
  },
  {
    "title": "Bhushi Dam",
    "description": "Bhushi Dam is a major tourist attraction especially in the rainy season, when overflowing water cascades over the steps and creates a natural foot spa. Located on the Indrayani River, it is surrounded by scenic greenery and rocky terrain. Visitors often come here to relax, enjoy the shallow water flows, and experience the area's monsoon magic."
  },
  {
    "title": "Lohagad Fort",
    "description": "Lohagad Fort is a historic hill fort situated at an elevation of around 1,033 meters. Built during the Maratha period, the fort is known for its sturdy architecture, panoramic views, and the long walk along the famous 'Vinchu Kata' (scorpion tail) rampart. A trek to this fort is both refreshing and educational, offering insights into regional history and architecture."
  },
  {
    "title": "Karla Caves",
    "description": "The Karla Caves are ancient Buddhist rock-cut cave shrines dating back to the 2nd century BCE. These caves house one of the largest and most well-preserved chaitya halls in India. The intricate sculptures, stone carvings, and the presence of a massive prayer hall make it a spiritual and archaeological marvel worth visiting."
  },
  {
    "title": "Bhaja Caves",
    "description": "Bhaja Caves are another group of Buddhist caves near Lonavala, predating the Karla caves. They consist of around 22 rock-cut structures that include stupas, prayer halls, and monk cells. With scenic surroundings and a nearby waterfall, these caves offer a perfect blend of spirituality, history, and nature."
  },
  {
    "title": "Pawna Lake",
    "description": "Pawna Lake is a man-made reservoir formed by the Pavana Dam, located a short drive from Lonavala. It's a favored spot for lakeside camping, bonfires, kayaking, and stargazing. Surrounded by mountains and historical forts like Tikona, Lohagad, and Tung, it offers a perfect combination of adventure and tranquility."
  },
  {
    "title": "Rajmachi Fort",
    "description": "Rajmachi Fort comprises two twin forts—Shrivardhan and Manaranjan—set on a plateau amidst dense forests. Trekkers often journey from Lonavala to the base village of Udhewadi and climb up to the fort. The fort ruins, temples, and extensive views from the top provide a rewarding experience, especially during the rainy season."
  },
  {
    "title": "Ryewood Park and Shivaji Udyan",
    "description": "Located near Lonavala market, Ryewood Park is a well-maintained garden ideal for families and children. With tall old trees, flower beds, and walking paths, the park also features a temple dedicated to Lord Shiva. It's a pleasant stop for a relaxed afternoon amidst greenery."
  },
  {
    "title": "Della Adventure Park",
    "description": "Della Adventure Park is one of India’s largest adventure parks, offering over 50 thrilling activities including bungee jumping, ATV rides, ziplining, and rock climbing. With luxury resort options and multiple restaurants on-site, it combines adrenaline-pumping excitement with leisure and hospitality."
  },
  {
    "title": "Sunset Point, Khandala",
    "description": "Located in nearby Khandala, Sunset Point offers sweeping views of the Sahyadri ranges. It's an ideal location to watch the sun dip below the hills, especially in the evening. Photographers and nature lovers frequent the point for its spectacular skies and calm ambiance."
  }
],

"services": [
    {
        "name": "Pune to Lonavala Cab Booking",
        "description": "Book your Pune to Lonavala cab hassle-free with Meghana Cab. Our reliable service ensures timely pickups, well-maintained vehicles, and experienced drivers to make your hill station journey smooth and enjoyable."
    },
    {
        "name": "One Way Taxi to Lonavala from Pune",
        "description": "Looking for a one-way taxi from Pune to Lonavala? Meghana Cab offers flexible and affordable one-way rides with door-to-door service, perfect for quick trips or day visits to this beautiful hill station."
    },
    {
        "name": "Round Trip Cab Pune to Lonavala",
        "description": "Plan your round trip to Lonavala with Meghana Cab for a stress-free journey. Enjoy competitive pricing, comfortable vehicles, and professional drivers who ensure you return safely and on time."
    },
    {
        "name": "AC Sedan for Pune to Lonavala Trip",
        "description": "Travel comfortably with Meghana Cab’s AC sedan service from Pune to Lonavala. Our sedans provide a smooth, cool, and quiet ride, making your scenic journey even more pleasant."
    },
    {
        "name": "SUV Hire Pune to Lonavala",
        "description": "Hire a spacious SUV for your Pune to Lonavala trip with Meghana Cab. Ideal for families or groups, our SUVs offer ample luggage space and a comfortable ride on the winding roads to Lonavala."
    },
    {
        "name": "Lonavala Sightseeing Cab from Pune",
        "description": "Explore Lonavala’s popular attractions with Meghana Cab’s sightseeing taxi service. Our knowledgeable drivers will take you to all must-visit spots, ensuring a memorable and hassle-free tour."
    },
    {
        "name": "Affordable Taxi Pune to Lonavala",
        "description": "Get budget-friendly taxi services from Pune to Lonavala with Meghana Cab. We combine affordability with quality service to offer you the best value for your travel money."
    },
    {
        "name": "Pune to Lonavala Weekend Trip Cab",
        "description": "Planning a weekend getaway to Lonavala? Book a taxi with Meghana Cab for a relaxing and enjoyable trip. We offer flexible scheduling and reliable rides tailored to weekend travelers."
    },
    {
        "name": "Family Cab to Lonavala from Pune",
        "description": "Travel with your family comfortably and safely from Pune to Lonavala using Meghana Cab’s family cab service. Spacious cars and child-friendly amenities make your trip stress-free."
    },
    {
        "name": "Local Cab Hire for Lonavala",
        "description": "Need a local cab around Lonavala? Meghana Cab offers flexible local hire options so you can explore the hill station at your own pace with reliable transportation."
    },
    {
        "name": "Pune to Lonavala Tour Package Taxi",
        "description": "Combine taxi services with sightseeing tours by booking a Pune to Lonavala tour package taxi. Meghana Cab provides customized itineraries and comfortable travel for a full Lonavala experience."
    },
    {
        "name": "24/7 Taxi Pune to Lonavala",
        "description": "Meghana Cab offers 24/7 taxi booking services from Pune to Lonavala. Whether you need a cab early morning or late at night, we’re available round the clock to serve your travel needs."
    },
    {
        "name": "Fast Cab Booking Pune to Lonavala",
        "description": "Need a quick taxi booking from Pune to Lonavala? Meghana Cab’s fast and easy booking system lets you schedule your ride instantly, ensuring no delays or waiting time."
    },
    {
        "name": "Budget Taxi Pune to Lonavala",
        "description": "Choose Meghana Cab’s budget taxi services for Pune to Lonavala travel. We offer competitive pricing without compromising on vehicle quality or driver professionalism."
    },
    {
        "name": "Cab with Driver Pune to Lonavala",
        "description": "Hire a cab with a professional driver from Pune to Lonavala for a relaxed journey. Meghana Cab ensures all drivers are trained, polite, and knowledgeable about the routes and local areas."
    }
],

"tableData": [
    ["Pune to Lonavala Cab Booking", "One Way Taxi to Lonavala from Pune"],
    ["Round Trip Cab Pune to Lonavala", "AC Sedan for Pune to Lonavala Trip"],
    ["SUV Hire Pune to Lonavala", "Lonavala Sightseeing Cab from Pune"],
    ["Affordable Taxi Pune to Lonavala", "Pune to Lonavala Weekend Trip Cab"],
    ["Family Cab to Lonavala from Pune", "Local Cab Hire for Lonavala"],
    ["Pune to Lonavala Tour Package Taxi", "24/7 Taxi Pune to Lonavala"],
    ["Fast Cab Booking Pune to Lonavala", "Budget Taxi Pune to Lonavala"],
    ["Cab with Driver Pune to Lonavala", ""],
    ["", ""]
],











"whychoose": [
    {
        "WhyChooseheading": "Comfortable Pune to Lonavala Taxi Service",
        "WhyChoosedescription": "Meghana Cab offers a smooth and relaxing taxi ride from Pune to Lonavala. Whether it's a quick weekend getaway, a family trip, or a romantic escape, enjoy a comfortable journey in our clean and well-maintained taxis."
    },
    {
        "WhyChooseheading": "On-Time Pick-Up and Drop",
        "WhyChoosedescription": "We value your time. Our Pune to Lonavala taxi service ensures punctual pick-up and drop-off so you can make the most of your day trip or vacation without any delays."
    },
    {
        "WhyChooseheading": "Experienced and Courteous Drivers",
        "WhyChoosedescription": "Our professional drivers know the Pune to Lonavala route well, including scenic spots and best travel times. They prioritize your safety, comfort, and a pleasant overall experience."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Enjoy budget-friendly Pune to Lonavala taxi fares with no hidden charges. Meghana Cab offers clear and competitive pricing so you can travel worry-free and within your budget."
    },
    {
        "WhyChooseheading": "Safe and Clean Vehicles",
        "WhyChoosedescription": "Your safety is our priority. All our taxis are regularly sanitized, well-maintained, and equipped with GPS tracking, seat belts, and air conditioning for a safe and comfortable ride."
    },
    {
        "WhyChooseheading": "24/7 Taxi Service from Pune to Lonavala",
        "WhyChoosedescription": "Planning an early morning trip or a late-night return? Meghana Cab offers 24/7 taxi availability from Pune to Lonavala, ensuring travel flexibility at your convenience."
    },
    {
        "WhyChooseheading": "One-Way and Round Trip Options",
        "WhyChoosedescription": "Whether you're going for a one-way drop or planning a round trip, Meghana Cab provides flexible travel options tailored to your needs for the Pune to Lonavala route."
    },
    {
        "WhyChooseheading": "Easy Online Booking and Support",
        "WhyChoosedescription": "Book your Pune to Lonavala taxi in minutes through our website or mobile app. Need help? Our friendly support team is available to assist you with any queries or special requests."
    }
]




















    }

const faqData = [
    {
        question: "How can I book a Pune to Lonavala taxi with Meghana Cab?",
        answer: "Booking a Pune to Lonavala taxi is simple with Meghana Cab. You can book online via our website or call us directly at +91 9075462128."
    },
    {
        question: "What taxi options are available for the Pune to Lonavala route?",
        answer: "We offer hatchbacks, sedans, SUVs, and tempo travellers for the Pune to Lonavala trip, depending on your travel needs and group size."
    },
    {
        question: "How long does it take to travel from Pune to Lonavala by taxi?",
        answer: "The journey from Pune to Lonavala takes approximately 1.5 to 2 hours depending on traffic and road conditions."
    },
    {
        question: "Is one-way taxi service available from Pune to Lonavala?",
        answer: "Yes, Meghana Cab provides affordable one-way as well as round-trip taxi services between Pune and Lonavala."
    },
    {
        question: "Are toll and parking charges included in the fare?",
        answer: "Toll and parking charges are additional and will be shared with you during the booking process for full transparency."
    },
    {
        question: "Do Meghana Cab drivers know the route to Lonavala well?",
        answer: "Yes, our drivers are experienced and familiar with the Pune to Lonavala route to ensure a smooth and safe journey."
    },
    {
        question: "Can I request stops at scenic points on the way to Lonavala?",
        answer: "Yes, you can request stops at key viewpoints or attractions along the way. Please inform us in advance when booking."
    },
    {
        question: "Is the Pune to Lonavala taxi service available at any time?",
        answer: "Yes, we offer 24/7 service, so you can book a ride to Lonavala at your convenience, whether day or night."
    },
    {
        question: "What payment methods are accepted for the Pune to Lonavala taxi?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash to make your payment process smooth and hassle-free."
    },
    {
        question: "How do I contact Meghana Cab for booking a taxi to Lonavala?",
        answer: "To book your taxi, call Meghana Cab at +91 9075462128. Our team is ready to assist you anytime."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Rahul Shinde',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Meghana Cab provided a great experience for our Pune to Lonavala trip. The driver was on time, and the cab was clean and comfortable. Will definitely book again!”',
    },
    {
        name: 'Ms. Neha Jagtap',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“I used Meghana Cab for a weekend getaway to Lonavala. The booking process was smooth, and the ride was safe and pleasant. Highly recommended!”',
    },
];















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Lonavala Taxi",
  "image": "https://www.meghanacabs.com/assets/images/pune-to-lonavala-taxi.jpg",
  "description": "Book Pune to Lonavala taxi with Meghana Cabs for one-way and round trips. Choose from AC Sedans, SUVs, and budget-friendly options. Ideal for sightseeing, weekend trips, and family travel.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5187"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1200",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-lonavala-taxi"
  }
};







    return (
        <div>

<Helmet>
  <title>Pune to Lonavala Taxi | One Way & Round Trip | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Lonavala taxi with Meghana Cabs for one-way and round trips. Choose from AC Sedans, SUVs, and budget-friendly options. Ideal for sightseeing, weekend trips, and family travel." 
  />
  <meta 
    name="keywords" 
    content="Pune to Lonavala Cab Booking, One Way Taxi to Lonavala from Pune, Round Trip Cab Pune to Lonavala, AC Sedan for Pune to Lonavala Trip, SUV Hire Pune to Lonavala, Lonavala Sightseeing Cab from Pune, Affordable Taxi Pune to Lonavala, Pune to Lonavala Weekend Trip Cab, Family Cab to Lonavala from Pune, Local Cab Hire for Lonavala, Pune to Lonavala Tour Package Taxi, 24/7 Taxi Pune to Lonavala, Fast Cab Booking Pune to Lonavala, Budget Taxi Pune to Lonavala, Cab with Driver Pune to Lonavala" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/8.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetolonavala;